import { Injectable } from "@angular/core";
import { Languages } from "../constants";

@Injectable({
  providedIn: "root",
})
export class CstLanguageService {

  public static currentAppLanguageStatic(): string{
    const langFromStorage = localStorage.getItem("selected-lang");
    if (langFromStorage && Languages.SupportedLanguages.includes(langFromStorage)) {
      return langFromStorage;
    }
    const browserLang =
      navigator.language || (navigator.languages && navigator.languages[0]);
    return browserLang.startsWith("de") ? "de" : "en";
  }


  public get supportedLanguages() {
    return Languages.SupportedLanguages;
  }
  public isSupported(langIso: any) {
    return Languages.SupportedLanguages.includes(langIso);
  }

  public get currentAppLanguage() {
    return CstLanguageService.currentAppLanguageStatic();
  }

  public get browserLanguage(): string {
    const browserLang =
      navigator.language || (navigator.languages && navigator.languages[0]);
    return browserLang.startsWith("de") ? "de" : "en";
  }

  public get currentSelectedLanguage(): string | null {
    return localStorage.getItem("selected-lang");
  }
  public set currentSelectedLanguage(value: string | null) {
    if (value === null) {
      localStorage.removeItem("selected-lang");
    } else {
      localStorage.setItem("selected-lang", value);
    }
  }


  public switchAppLanguage(requestedLang: string) {
    const langIso = requestedLang.startsWith("de") ? "de" : "en";

    if (!this.isSupported(langIso)) {
      return;
    }

    const currentAppLang = this.currentAppLanguage;

    if (langIso === this.browserLanguage) {
      this.currentSelectedLanguage = null;
    } else {
      this.currentSelectedLanguage = langIso;
    }

    if (requestedLang !== currentAppLang) {
      window.location.reload();
    }
  }
}